// extracted by mini-css-extract-plugin
module.exports = {"box":"Explain_style_box__1atD-"};